import { AuthenticationMethod, CreateAuthMethodProps } from 'auth/types/authentication-method.type';
import { createWebsealAuthMethod } from './webseal/webseal-auth-method';
import { createGatewayAuthMethod } from './gateway/gateway-auth-method';
import { createIbmGrantAuthMethod } from './ibm-grant/ibm-grant-auth-method';
import { createAfAuthMethod } from './af/af-auth-method';

export const createAuthMethod = (props: CreateAuthMethodProps): AuthenticationMethod => {
  if (props.method === 'webseal') return createWebsealAuthMethod(props);
  if (props.method === 'gateway') return createGatewayAuthMethod(props);
  if (props.method === 'ibmGrant') return createIbmGrantAuthMethod(props);
  if (props.method === 'afSso') return createAfAuthMethod(props);
  throw new Error('Authentication method is not supported.');
};
